import React from 'react';

import { SMPFlex, SMPImage, SMPText, styled } from '@velinsi/smp-widgets-ui';
import { EventResultType, StatusType, WinnerType } from '../../../../../packages/types/multisportApi';
import { setNationalParticipantBorder } from '@sportal365/smp-widget-utils';

const TennisScoreContainer = styled('div', {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'flex',
  height: '20px',
});

interface TeamScoreProps {
  name: string;
  img: string | null;
  results: EventResultType[];
  status: StatusType;
  isWinner?: boolean;
  score: number | string | null;
}

const TENNIS_SETS = ['set1', 'set2', 'set3', 'set4', 'set5'];

export const TennisScore: React.FC<TeamScoreProps> = ({ name, img, results, isWinner, score, status }) => {
  const filteredResults = results?.filter((result) => result.type !== null && TENNIS_SETS.includes(result.type));

  return (
    <TennisScoreContainer>
      <SMPFlex align='center' css={{ mr: '$4' }}>
        {img && <SMPImage width={'16px'} css={{ mr: '$1', ...setNationalParticipantBorder(true) }} src={img} alt='Server img' />}
        <SMPText
          weight={isWinner ? 700 : 400}
          css={{ fontSize: '$2_5', color: !isWinner && status === 'FINISHED' ? '$teamLostColor' : '$multiSportTextColor' }}
        >
          {name}
        </SMPText>
      </SMPFlex>
      {filteredResults && filteredResults.length > 0 ? (
        <SMPFlex gap={'sm'}>
          {score && (
            <SMPText size='2_5' css={{ lineHeight: '$4', width: '$3', color: '$multisportHighlightColor', ta: 'center' }}>
              {score}
            </SMPText>
          )}
          {filteredResults.map((result, index) => (
            <SMPText
              size='2_5'
              key={index}
              weight={result.winner === WinnerType.YES ? 700 : 400}
              css={{
                lineHeight: '$4',
                width: '$3',
                color: result.winner === WinnerType.YES ? '$multiSportTextColor' : '$teamLostColor',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {result.value}
              {result.tiebreakValue && <sup style={{ fontSize: '8px' }}>{result.tiebreakValue}</sup>}
            </SMPText>
          ))}
        </SMPFlex>
      ) : (
        <SMPText css={{ fontSize: '12px', color: '$multiSportTextColor' }}>{'-'}</SMPText>
      )}
    </TennisScoreContainer>
  );
};
